import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { LayoutDashboard, FolderKanban, Ticket, Users, LogOut, Lightbulb, FileBarChart, Activity, Clock } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '@/firebase';

export default function Layout({ children, user }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      // 🔐 1. Firebase logout (MOST IMPORTANT)
      await signOut(auth);

      // 🧹 2. Clear local storage
      localStorage.removeItem("loginTime");
      localStorage.removeItem("user");

      // 🚫 3. Replace route (no back button)
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/tickets', icon: Ticket, label: 'Tickets' },
    { path: "/ideas", icon: Lightbulb, label: "Ideas" }

  ];

  const isSuperAdmin = user?.role === 'super_admin' || user?.role === 'superadmin';
  const isAdmin = user?.role === 'super_admin' || user?.role === 'superadmin' || user?.role === 'admin';

  if (isSuperAdmin) {
    navItems.push({ path: '/timesheet', icon: Clock, label: 'Timesheet' });
  }

  if (isAdmin) {
    navItems.push({ path: '/reports', icon: FileBarChart, label: 'Reports' });
    navItems.push({ path: '/performance', icon: Activity, label: 'Performance' });
    navItems.push({ path: '/users', icon: Users, label: 'Users' });
    navItems.push({ path: '/projects', icon: FolderKanban, label: 'Projects' });
    navItems.push({ path: '/logs1', icon: FolderKanban, label: 'Logs' });
    navItems.push({ path: '/auth-logs', icon: FolderKanban, label: 'Auth Logs' });

  }

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#f8fafc' }}>
      <aside className="w-64 bg-white border-r border-gray-200 flex flex-col">
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif', color: '#1e293b' }}>
            TicketHub
          </h1>
          <p className="text-sm text-gray-500 mt-1">{user?.role.replace('_', ' ').toUpperCase()}</p>
        </div>
        <nav className="flex-1 p-4 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path}>
                <Button
                  variant={isActive ? 'default' : 'ghost'}
                  className="w-full justify-start"
                  data-testid={`nav-${item.label.toLowerCase()}`}
                >
                  <Icon className="mr-2 h-4 w-4" />
                  {item.label}
                </Button>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-gray-200">
          <div className="mb-3 px-2">
            <p className="text-sm font-medium text-gray-900">{user?.name}</p>
            <p className="text-xs text-gray-500">{user?.email}</p>
          </div>
          <Button variant="outline" className="w-full justify-start" onClick={handleLogout} data-testid="logout-btn">
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="p-8">{children}</div>
      </main>
    </div>
  );
}